export class CustomerPermitTypeValueConverter {
  static x = {
    RETAIL_LICENCE: 'Salgsbevilling',
    LIQUOR_LICENSE_GROUP_1: 'Skjenkebevilling gruppe 1',
    LIQUOR_LICENSE_GROUP_2: 'Skjenkebevilling gruppe 1 og 2',
    LIQUOR_LICENSE_GROUP_3: 'Skjenkebevilling gruppe 1, 2 og 3',
  };

  toView(value) {
    return CustomerPermitTypeValueConverter.toView(value);
  }

  static toView(value) {
    return this.x[value];
  }
}
